import '../../modules/mode-components';

import { Logger } from '@mode/shared/contract-common';
import * as angular from 'angular';
import * as _ from 'lodash';
import MoveSpaceModalController from './move-space-modal-controller';
import { MoveSpaceModalService } from './move-space-modal.service';
import template from './shortcut-space-modal.html';

function openSpacesNotInSpace(excludedSpaceToken, space) {
  return !space.community && !space.private && space.token !== excludedSpaceToken;
}

const shortcutSpaceDirective = function (
  Modal,
  SpaceLinkModel,
  moveSpaceModalService: MoveSpaceModalService,
  AlertService,
  $log: Logger,
  $q
) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      space: '<',
      owner: '<',
      account: '<',
      movedToSpace: '&',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.shortcutSpace', (event) => {
        const workspaceCollections = moveSpaceModalService.getCustomSpaces($scope.owner);

        $q.all([$scope.report.spaceLinks({ refresh: true }), workspaceCollections]).then(
          $q.spread(getElementsAndHandleModal.bind(this))
        );
      });

      function getElementsAndHandleModal(spaceLinks, spaces: any[]) {
        spaceLinks.elements().then((spaceLinks) => handleModal(spaceLinks, spaces));
      }

      function handleModal(spaceLinks, spaces) {
        const excludedSpaceToken = $scope.space ? $scope.space.token : '';
        const filteredSpaces = spaces
          .filter(openSpacesNotInSpace.bind(this, excludedSpaceToken))
          // alphabetize
          .sort((a, b) => a.name.localeCompare(b.name));

        const modal = Modal.open(
          {
            spaces: filteredSpaces,
            owner: $scope.owner,
            account: $scope.account,
            currSpace: $scope.space,
          },
          {
            controller: MoveSpaceModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );

        modal.result.then(saveSpaceLink.bind(this, spaceLinks)).catch(function () {});
      }

      function saveSpaceLink(spaceLinks, options) {
        const space = options.$space;
        const moveToSpace = options.$noMove;
        $scope.report.space_token = space.token;

        if (_.find(spaceLinks, (link: any) => link.space_token === space.token)) {
          AlertService.success('Shortcut created');
          moveToSpace && $scope.movedToSpace({ $space: space });
        } else {
          SpaceLinkModel.create({
            report: $scope.report.token,
            params: {
              'space_link.space_token': space.token,
              includes: ['space'],
            },
          })
            .then((newSpaceLink) => {
              AlertService.success('Shortcut created');
              moveToSpace && $scope.movedToSpace({ $space: space });
            })
            .catch((e) => {
              $log.log('error adding space', e);
              AlertService.error('Failed to create shortcut');
            });
        }
      }

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.shortcutSpace'));
    },
  };
};

shortcutSpaceDirective.$inject = [
  'ModalService',
  'SpaceLinkModel',
  'MoveSpaceModalService',
  'ToastService',
  '$log',
  '$q',
];

angular.module('mode.components').directive('shortcutSpace', shortcutSpaceDirective);
